import Icon from "atoms/Icon";
import Text from "atoms/Text";
import moment from "moment";
import { useEffect, useRef, useState } from "react";

const AllocationTooltipContent = ({ tooltip }) => {
  const tooltipRef = useRef(null);
  const [adjustedLeft, setAdjustedLeft] = useState(tooltip.pos.x - 10);
  const [alignRight, setAlignRight] = useState(false);

  useEffect(() => {
    if (tooltipRef.current) {
      const rect = tooltipRef.current.getBoundingClientRect();
      const windowWidth = window.innerWidth;
      if (rect.right > windowWidth) {
        setAdjustedLeft(tooltip.pos.x - (rect.width - 14));
        setAlignRight(true);
      } else {
        setAdjustedLeft(tooltip.pos.x - 10);
        setAlignRight(false);
      }
    }
  }, [tooltip.pos.x]);

  return (
    <div
      ref={tooltipRef}
      className="fixed bg-[#F9F9FB] border border-[#F9F9FB] z-[9999] pointer-events-none shadow-tooltip max-w-[275px] w-full"
      style={{ left: adjustedLeft, top: tooltip.pos.y + 10 }}
    >
      <div className={`absolute w-2.5 h-2.5 transform rotate-45 -top-[5px] ${alignRight ? 'right-2' : 'left-2'} bg-[#F9F9FB] shadow-tooltip border border-gray-300`} />
      <div className="bg-[#F9F9FB] p-4 relative z-10 flex flex-col gap-y-2 max-w-[350px]">
        <div className="flex gap-4">
          <div className="p-1 text-white max-w-max text-xs capitalize" style={{ backgroundColor: tooltip.data.typeColor }}>
            {tooltip.data.type}
          </div>
          {
            tooltip.data.shortlistedType &&
            <div className="p-1 text-white max-w-max text-xs capitalize" style={{ backgroundColor: tooltip.data.typeColor }}>
              {tooltip.data.shortlistedType}
            </div>
          }
           {
            tooltip.data.isDraft &&
            <div className="p-1 text-white max-w-max text-xs capitalize bg-gray-700">
              Draft
            </div>
          }
        </div>
        <Text variant="labelSemibold">{tooltip.data.name.slice(0, 30)} {tooltip.data.name.length > 30 && `...`} {tooltip.data.spineCode && ` (${tooltip.data.spineCode})`}</Text>
        <div className="flex flex-col items-start">
          <div className='flex items-center gap-x-0.5'>
            <Icon icon='calendar__l__stroke' />
            <span className="text-[10px]">Start date: {moment(tooltip.data.startDate).format('MM/DD/YYYY')} - End date: {moment(tooltip.data.endDate).format('MM/DD/YYYY')}</span>
          </div>
          {
            tooltip.data.weeklyHours &&
            <div className='flex items-center gap-x-0.5'>
              <Icon icon='clock__l__stroke' />
              <span className="text-[10px]">Work hours: {tooltip.data.weeklyHours}hrs/ week</span>
            </div>
          }
          {/* <div className='flex items-center gap-x-0.5'>
            <Icon icon='location__l__stroke' />
            <span className="text-[10px]">Work location: {tooltip.data.workLocation}</span>
          </div> */}
        </div>
        {/* <div className="flex gap-4">
          <div>
            <Text variant="labelSmall" color="text-gray-1000">Engagement partner</Text>
            <Text variant="labelSemibold">{tooltip.data.engagementPartner ? tooltip.data.engagementPartner : '-'}</Text>
          </div>
           <div>
            <Text variant="labelSmall" color="text-gray-1000">Engagement manager</Text>
            <Text variant="labelSemibold">{tooltip.data.engagementManager ? tooltip.data.engagementManager : '-'}</Text>
          </div>
        </div> */}
      </div>
    </div>
  );
};



export default AllocationTooltipContent;


